
  import {
    date,
    QCard,
    QCardActions,
    QCardSection,
    QCarousel,
    QCarouselSlide,
    QChip,
    QInnerLoading,
    QInput,
    QItem,
    QItemLabel,
    QItemSection,
    QLinearProgress,
    QSpinner,
    QSpinnerGears,
    QSpinnerPuff
  } from 'quasar'
  import {parseISO, add} from 'date-fns'
  import {numeric, required} from 'vuelidate/lib/validators'
  import {convertToISO_8601_String} from '../../../utils/date-utils'
  import {dateUtils} from '@parantion/components'
  const {distanceInWordsToNow} = dateUtils

  export default {
    components: {
      QItem,
      QItemLabel,
      QItemSection,
      QCarouselSlide,
      QCarousel,
      QChip,
      QSpinner,
      QSpinnerPuff,
      QInnerLoading,
      QLinearProgress,
      QSpinnerGears,
      QInput,
      QCard,
      QCardSection,
      QCardActions
    },

    props: {
      loading: {
        type: Boolean,
        default: false
      },
      firstTimeLoading: {
        type: Boolean,
        default: true
      },
      respondentsToUse: {
        type: Number
      }
    },

    filters: {
      dateFilter: value => value ? convertToISO_8601_String(value, 'dd-MM-yyyy') : '',
    },

    data () {
      return {
        showAddNewSurveyCard: false,
        filter: 'all',
        isEdge: false,
        selectedTab: 0,
        isAdding: false,
        user: this.$store.state.parantion.user.user,
        isRedirecting: false,
        newSurvey: {
          frm_label: null,
          respondents: null

        },
        showing: true,
        searchItem: '',
        upsellModalClicked: false
      }
    },

    watch: {
      searchItem: function () {
        this.$refs.carousel && this.$refs.carousel.goTo(0)
      }
    },

    computed: {
      sort () {
        return this.$store.state.survey.sortBy
      },
      surveys () {
        return this.$store.getters['survey/getSurveys']
      },
      screenWidth () {
        if (self.innerWidth) return self.innerWidth
        if (document.documentElement && document.documentElement.clientWidth) return document.documentElement.clientWidth
        if (document.body) return document.body.clientWidth
      },
      isTabletAndSmaller () {
        return this.screenWidth <= 1224
      },
      pagedSurveys () {
        let size = 12
        let surveys = this.showAddNewSurveyCard ? [{isNew: true, frm_label: ''}, ...this.surveys] : this.surveys
        let filteredSurveys = this.showAddNewSurveyCard ? [{isNew: true, frm_label: ''}, ...this.surveys] : this.surveys
        if (this.screenWidth >= 1224 && this.screenWidth <= 1536) size = 8
        if (this.screenWidth >= 1024 && this.screenWidth <= 1223) size = 6
        if (this.screenWidth <= 1023) size = 4
        if (this.searchItem) {
          filteredSurveys = surveys.filter(survey => {
            if (survey.isNew) return false
            return survey.frm_label.toLowerCase().includes(this.searchItem.toLowerCase()) ||
                    this.$options.filters.dateFilter(survey.fields.frm_date_start).includes(this.searchItem.toLowerCase())
          })
        }

        if (this.filter === 'all') {
          surveys = filteredSurveys
        } else if (this.filter === 'open') {
          surveys = filteredSurveys.filter(srv => this.isOpen(srv))
        } else if (this.filter === 'closed') {
          surveys = this.surveys.filter(srv => !this.isOpen(srv))
        }
        return surveys.reduce((acc, curr, i, self) => {
          if (!(i % size)) {
            return [...acc, self.slice(i, i + size)]
          }
          return acc
        }, [])
      },
      mobileSurveys () {
        let surveys = this.surveys
        let filteredSurveys = this.surveys

        if (this.searchItem) {
          filteredSurveys = surveys.filter(survey => {
            return survey.frm_label.toLowerCase().includes(this.searchItem.toLowerCase()) ||
                    this.$options.filters.dateFilter(survey.fields.frm_date_start).includes(this.searchItem.toLowerCase())
          })
        }

        if (this.filter === 'open') {
          surveys = filteredSurveys.filter(srv => this.isOpen(srv))
        } else if (this.filter === 'closed') {
          surveys = filteredSurveys.filter(srv => !this.isOpen(srv))
        } else {
          surveys = filteredSurveys
        }
        return surveys
      },
      amountOpen () {
        let count = 0
        for (let srv of this.surveys) {
          if (this.isOpen(srv)) count += 1
        }
        return count
      },
      amountClosed () {
        let count = 0
        for (let srv of this.surveys) {
          if (!this.isOpen(srv)) count += 1
        }
        return count
      },
      respondentsLeft () {
        return this.$store.state.parantion.user.user.nonamed_users_granted - this.$store.state.parantion.user.user.nonamed_users_used
      },
      surveysLeft () {
        return this.$store.state.parantion.user.user.forms_granted - this.$store.state.parantion.user.user.forms_used
      },
      expirationDate () {
        if (this.user.account_valid) {
          return convertToISO_8601_String(this.user.account_valid, 'dd-MM-yyyy')
        } else {
          return '-'
        }
      },
      diffInDays () {
        if(this.user.account_valid){
          return this.$t('surveys.expiration_date_account.label', {TimeInWords: this.timeInWords(new Date(this.user.account_valid.replace(/\s/, 'T')))})
        } else return ''
      }
    },

    created () {
      let isIE = !!document.documentMode
      this.isEdge = !isIE && !!window.StyleMedia

      window.vm = this
      window.onfocus = function () {
        if (vm.upsellModalClicked) {
          vm.upsellModalClicked = false
          vm.$store.dispatch('user/getUpsellableFields')
        }
      }

    },

    validations: {
      newSurvey: {
        frm_label: {
          required
        },
        respondents: {
          numeric,
          maxValue: function (text) {
            if (!text) {
              text = 0
            }
            return text <= this.respondentsToUse
          }
        }
      }
    },

    methods: {
      showNewSurveyCard () {
        if (!this.isTabletAndSmaller && this.$refs.carousel) this.$refs.carousel.goTo(0)

        this.showAddNewSurveyCard = true
        this.filter = 'all'
      },

      async createNewSurvey () {
        if (this.$v.$invalid) return
        this.isAdding = true
        try {
          const form = await this.$store.dispatch('survey/createNewSurvey', this.newSurvey)
          this.showAddNewSurveyCard = false
          this.isAdding = false

          if (!form.fh) this.$toasty.error('Onderzoek aanmaken is niet gelukt.')

          const newSurveyHash = form.fh
          await this.setActiveSurvey(newSurveyHash)

          this.$toasty.success(this.$t('surveys.new_survey_added.msg'))
          this.$router.push({name: 'SurveyDetails', params: {surveyHash: newSurveyHash}})
          this.newSurvey.isNew = undefined
        } finally {
          this.isAdding = false
          this.cancel()
        }
      },

      async setActiveSurvey (newSurveyHash) {
        const surveys = this.surveys
        const storedSurvey = surveys.find(s => s.fid === newSurveyHash)

        this.$store.commit('survey/SET_ACTIVE_SURVEY', storedSurvey)
        await this.$store.dispatch('survey/getTemplate')
        this.$store.dispatch('parantion/user/getUserFields', this.$store.state.parantion.user.user.uh)
      },

      cancel () {
        this.showAddNewSurveyCard = false
        this.newSurvey.frm_label = null
        this.newSurvey.respondents = null;
        this.$nextTick(() => {
          this.$v.newSurvey.frm_label.$reset();
          this.$v.newSurvey.respondents.$reset();
        })
      },

      async openSurveyDetail (survey) {
        this.$router.push({name: 'SurveyDetails', params: {surveyHash: survey.fid}})
        this.$store.commit('survey/SET_ACTIVE_SURVEY', survey)
        this.$store.dispatch('survey/getTemplate')
        this.$store.dispatch('survey/getReportSettings')
      },

      setFilter (value) {
        if (this.surveys[0].isNew) return
        if (!this.isTabletAndSmaller && this.$refs.carousel) this.$refs.carousel.goTo(0)
        this.filter = this.filter === value ? 'all' : value
      },

      isOpen (survey) {
        return this.isExpired(survey) ? false : survey['frm_status'] === 1
      },

      isExpired (survey) {
        if (!survey.fields || !survey.fields.frm_date_end) return
        return (new Date(survey.fields.frm_date_end) < new Date())
      },

      isConcept (survey) {
        return (survey.progress.progress_idle === 0 && survey.frm_nonamed_users_used === 0) || (this.respondentsInvited(survey) === 0)
      },

      respondentsInvited (survey) {
        if (!survey.progress) return survey.fields.frm_nonamed_users_used;
        return survey.progress.progress_busy + survey.progress.progress_done + survey.progress.progress_invite + survey.progress.progress_remind
      },

      timeInWords (dateValue) {
        return distanceInWordsToNow(parseISO(convertToISO_8601_String(dateValue)))
      },

      showWarningSign (type) {
        switch (type) {
          case 'account_valid':
            const today = new Date()
            const accountDate = new Date(this.user.account_valid)
            const endDate = add(today, {days: 21})
            if (date.isBetweenDates(accountDate, today, endDate)) return true
            break
          case 'respondents':
            if (this.user.nonamed_users_used === 0 || this.user.nonamed_users_used === null) return
            const total = this.user.nonamed_users_granted
            const perctFree = Math.round(((total - this.user.nonamed_users_used) / total) * 100)
            return perctFree <= 20
          case 'surveys':
            if (this.user.forms_used === 0 || this.user.forms_used === null) return
            const totalForms = this.user.forms_granted
            const left = totalForms - this.user.forms_used
            if (totalForms >= 100 && left <= 5) {
              return true
            } else if (totalForms !== 0 && left <= 1) return true
            break
        }
      },

      openWindow (value) {
        let win = window.open(value, '_blank')
        win.focus()
      },

      clickModalButton (value) {
        this.upsellModalClicked = true
        this.openWindow(value)
      },

      setSort (type) {
        this.$store.dispatch('survey/setSort', type)
      }
    }
  }
